// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B7MtK","left":"styles_left__1RANX"};